import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get(taxid) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/register-customer/${taxid}`, options)
        .then(response => {
            let customer = jsona.deserialize(response.data);
            return customer;
        });
}

export default {
    get
};